<template>
  <div class>
    <div class="flexStart card-box">
      <div v-for="(item,index) in bacnkList" :key="item.id">
        <div
          class="finance-card"
          :class="'card-' + dict.bankListMap[item.bank]"
          @click="changeBank(index,item)"
        >
          <img class="bank-org-img" src="../../../../assets/images/bank/org.png" />
          <svg v-show="activeIndex==index" class="icon active-icon" aria-hidden="true">
            <use xlink:href="#gold-icon-wancheng" />
          </svg>
          <div class="finance-card-head spaceLeft">
            <span :class="dict.bankListMap[item.bank]" class="logo"></span>
            <div class="ellipsis">
              <span>{{getBankName(item.tenantNameShort || item.tenantName).first}}银行</span>
              <span
                style="font-size:14px;margin:0 3px 0 0;"
                v-if="getBankName(item.tenantNameShort || item.tenantName).second"
              >
                <span style="position: relative;top: -2px;">|</span>
                {{getBankName(item.tenantNameShort || item.tenantName).second}}
              </span>
            </div>
          </div>
          <div class="finance-card-main">
            <table class="finance-card-text">
              <tr>
                <td style="text-align:right">融资金额：</td>
                <td class="finance-card-span">
                  <span v-if="item.tenantId">{{item.applyAmt | splitK}}</span>
                  <span v-else>--</span>
                </td>
                <td>元</td>
              </tr>
              <tr>
                <td style="text-align:right">息费合计：</td>
                <td class="finance-card-span">
                  <span v-if="item.tenantId">{{item.estInt | splitK}}</span>
                  <span v-else>--</span>
                </td>
                <td>元</td>
              </tr>
              <tr>
                <td style="text-align:right">平台服务费：</td>
                <td class="finance-card-span">
                  <span v-if="item.tenantId">{{item.platformInt | splitK}}</span>
                  <span v-else>--</span>
                </td>
                <td>元</td>
              </tr>
              <tr>
                <td style="text-align:right">合计金额：</td>
                <td class="finance-card-span">
                  <span v-if="item.tenantId">{{item.totalAmt | splitK}}</span>
                  <span v-else>--</span>
                </td>
                <td>元</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="err-box" v-if="item.error">
          <div
            class="err-item text-color-red"
            v-if="dict.bankListMap[item.bank] != 'nongye'"
          >{{item.error}}</div>
          <template v-else>
            <div class="spaceLeft" v-if="item.code == '40038105'">
              <div class="err-item text-color-red">尚未申请准入！</div>
              <a @click="bankBuildApplay(item)">立即申请准入？</a>
            </div>
            <div class="spaceLeft" v-else-if="item.code == '40038101'">
              <div class="err-item text-color-red">银行正在准备入中，请等待</div>
            </div>
            <div class="spaceLeft" v-else-if="item.code == '40038102'">
              <div class="err-item text-color-red">{{item.error}}</div>
              <span>
                若已修正，
                <a @click="bankBuildApplay(item)">再次申请准入？</a>
              </span>
            </div>
            <div class="spaceLeft" v-else>
              <div class="err-item text-color-red">{{item.error}}</div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="common-title" style="margin-top:16px;">祺信融资明细</div>
    <div class="table-common">
      <a-table
        class="no-scroll"
        :pagination="false"
        size="middle"
        :columns="columns"
        :key="1"
        :row-key="record => record.gldId"
        :data-source="tableData"
        bordered
        :locale="{emptyText: '暂无数据'}"
      >
        <template slot="thsFncAmt" slot-scope="text">{{text | splitK}}</template>
        <template slot="exDay" slot-scope="text">{{text | dateFormat('YYYY-mm-dd')}}</template>
        <template slot="expectDate">{{feeData.expectDate}}</template>
        <template slot="loanDays">{{feeData.loanDays}}</template>
        <template slot="fee">{{feeData.fee | splitK}}</template>
        <template slot="yrRate">{{(feeData.yrRate)||0}}</template>
        <template slot="interest">{{feeData.interest | splitK}}</template>
        <template slot="platformInt">{{feeData.platformInt | splitK}}</template>
        <template slot="totalAmt">{{feeData.totalAmt | splitK}}</template>
      </a-table>
    </div>
    <div v-if="tableData.length > 0" class="text-color-orange">
      <div>温馨提示：实际放款日期和收款金额等以银行放款信息为准！</div>
      <div
        v-if="+submitResData.approveType===0"
        style="margin-left:69px;"
      >{{bacnkList[activeIndex].tenantName}}预估融资审批时间为{{submitResData.approveTime}}小时</div>
      <div
        v-if="+submitResData.approveType===1"
        style="margin-left:69px;"
      >{{bacnkList[activeIndex].tenantName}}为系统自动审批，提交融资申请审批通过之后，最快可实现1分钟内放款。</div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import { submitForm, bankBuildingApi } from '@/api/sell.js'
export default {
  props: {
    params: {
      type: [Array, Object],
    },
  },
  components: {},
  data() {
    return {
      columns: [
        {
          title: '祺信编号',
          dataIndex: 'gldId',
        },
        {
          title: '开立方',
          dataIndex: 'estbNm',
        },
        {
          title: '融资金额(元)',
          dataIndex: 'thsFncAmt',
          scopedSlots: { customRender: 'thsFncAmt' },
        },
        {
          title: '到期日期',
          dataIndex: 'exDay',
          scopedSlots: { customRender: 'exDay' },
        },
        {
          title: '放款日期',
          dataIndex: 'expectDate ',
          scopedSlots: { customRender: 'expectDate' },
        },
        {
          title: '融资天数',
          dataIndex: 'loanDays',
          scopedSlots: { customRender: 'loanDays' },
        },
        {
          title: '利率',
          dataIndex: 'yrRate',
          scopedSlots: { customRender: 'yrRate' },
        },
        {
          title: '利息',
          dataIndex: 'interest',
          scopedSlots: { customRender: 'interest' },
        },
        {
          title: '融资手续费',
          dataIndex: 'fee',
          scopedSlots: { customRender: 'fee' },
        },
        {
          title: '平台服务费',
          dataIndex: 'platformInt',
          scopedSlots: { customRender: 'platformInt' },
        },
        {
          title: '合计金额',
          dataIndex: 'totalAmt',
          scopedSlots: { customRender: 'totalAmt' },
        },
      ],
      formData: {},
      feeData: {
        applyAmt: undefined,
        bank: undefined,
        estInt: undefined,
        expectDate: undefined,
        fee: undefined,
        interest: undefined,
        loanDays: undefined,
        platformInt: undefined,
        tenantName: undefined,
        tenantOrgCode: undefined,
        totalAmt: undefined,
      },
      tableData: [],
      bacnkList: [],
      activeIndex: undefined,
      submitResData: {},
    }
  },
  computed: {
    ...mapGetters({
      userObj: 'home/getUserObj',
      getGoldDetailPrarms: 'app/getFinancingDetailPrarms',
      getSessionData: 'home/getSessionData',
    }),
  },
  methods: {
    ...mapMutations({
      setBuyOrSell: 'app/setBuyOrSell',
      setFinancingDetailPrarms: 'app/setFinancingDetailPrarms',
    }),
    changeBank(index, item) {
      if (!item.tenantId) {
        return
      }
      this.activeIndex = index
      this.submitForm()
    },
    initData() {
      this.tableData =
        this.getGoldDetailPrarms && this.getGoldDetailPrarms.requestData
          ? this.getGoldDetailPrarms.requestData.list[0].goldList
          : []
      this.formData =
        (this.getGoldDetailPrarms &&
          this.getGoldDetailPrarms.requestData &&
          this.getGoldDetailPrarms.requestData.map) ||
        {}
      this.feeData = this.getGoldDetailPrarms
        ? this.getGoldDetailPrarms.feeData
        : {}
      this.bacnkList = this.params && this.params.routeList
      console.log(this.bacnkList)
    },
    // 申请银行建档
    bankBuildApplay(item) {
      const self = this
      this.$confirm({
        title: '准入申请',
        content: '请确认进行准入申请？',
        onOk() {
          return new Promise((resolve, reject) => {
            bankBuildingApi(item.bank, item.id)
              .then((res) => {
                self.$message.success('准入申请已提交，请等待银行审批！')
                self.submitForm()
                resolve()
              })
              .catch((err) => {
                reject()
              })
          }).catch(() => console.log('Oops errors!'))
        },
        onCancel() {},
      })
    },
    submitForm() {
      if (!(this.params && this.params.submitParams)) {
        this.$parent.goback()
        return
      }
      this.bacnkList.forEach((i, index) => {
        if (i.tenantId) {
          this.$set(this.bacnkList[index], 'error', undefined)
        }
      })
      submitForm(
        {
          ...this.params.submitParams,
          id: this.bacnkList[this.activeIndex].id,
          bankCd: this.bacnkList[this.activeIndex].bank,
          tenantId: this.bacnkList[this.activeIndex].tenantId,
          lmtBusinessInfEntity:
            this.bacnkList[this.activeIndex].lmtBusinessInfEntity,
        },
        'loading',
        'noFailMsg'
      )
        .then((res) => {
          if (res.code != 200) {
          }
          let resData = res.data
          this.submitResData = res.data
          const esPrams = {
            lendFormListStr: JSON.stringify(res.data.list),
            formStr: JSON.stringify(res.data.map),
            tenantId: this.bacnkList[this.activeIndex].tenantId,
            lmtBusinessInfEntity:
              this.bacnkList[this.activeIndex].lmtBusinessInfEntity,
          }
          if (resData.financingDTO) {
            this.bacnkList[this.activeIndex].estInt =
              resData.financingDTO.estInt
            this.bacnkList[this.activeIndex].platformInt =
              resData.financingDTO.platformInt
            this.bacnkList[this.activeIndex].totalAmt =
              resData.financingDTO.totalAmt
            this.bacnkList[this.activeIndex].yrRate =
              resData.financingDTO.yrRate
            this.bacnkList[this.activeIndex].interest =
              resData.financingDTO.interest
            this.bacnkList[this.activeIndex].fee = resData.financingDTO.fee
            this.bacnkList[this.activeIndex].tenantNm = resData.tenantNm
          }
          this.setFinancingDetailPrarms({
            feeData: this.bacnkList[this.activeIndex],
            selectedRows: [this.params.info],
            requestData: resData,
            esPrams: esPrams,
          })
          this.initData()
        })
        .catch((err) => {
          this.$set(this.bacnkList[this.activeIndex], 'error', err.description)
          this.$set(this.bacnkList[this.activeIndex], 'code', err.code)
          this.setFinancingDetailPrarms({
            feeData: this.bacnkList[this.activeIndex],
            selectedRows: [this.params.info],
            requestData: null,
            esPrams: null,
          })
          this.initData()
          return
        })
    },
    check() {
      return new Promise((resolve, reject) => {
        if (this.bacnkList[this.activeIndex].error) {
          this.$message.error(this.bacnkList[this.activeIndex].error)
          reject(this.bacnkList[this.activeIndex].error)
          return
        }
        if (this.activeIndex === undefined) {
          this.$message.error('请选择资金方')
          reject('请选择资金方')
        }
        resolve({
          ...this.params,
          bankChecked: this.bacnkList[this.activeIndex],
        })
      })
    },
    getBankName(name = '') {
      const nameList = name.split('银行')
      return {
        first: nameList[0] || '',
        second: nameList[1] || '',
      }
    },
  },
  created() {
    this.bacnkList = this.params && this.params.routeList
  },
  mounted() {},
  watch: {
    params(newVal) {
      this.initData()
    },
  },
}
</script>
<style scoped lang="less">
.finance-card {
  width: 281px;
  border-radius: 4px;
  padding: 0 16px 13px 16px;
  .finance-card-head {
    height: 48px;
    line-height: 48px;
    font-size: 18px;
    color: #fff;
    flex-wrap: nowrap;
  }
  .finance-card-text {
    font-size: 14px;
    margin-top: 4px;
    color: #fff;
    .finance-card-span {
      text-align: right;
      padding-right: 10px;
    }
  }
  .active-icon {
    position: absolute;
    right: -10px;
    top: -10px;
    font-size: 28px;
  }
}
.no-scroll {
  th,
  td {
    white-space: nowrap;
  }
}
.err-box {
  margin: -8px 16px 0 16px;
  width: 260px;
}
.card-box {
  margin-top: -24px;
  padding-top: 24px;
  width: 100%;
  overflow-x: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/circulation/gold-financing/gold-financing-steps/gold-financing-step1.vue